import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import "./App.css";
import { Header } from "./Header";
import { IReduxState } from "../../../store";
import { IParentStudentItem } from "../../../store/focusEcoleSlice";

// export interface IListeEtatProps {
//   dataFiltered: IParentStudentItem[];
//   currentEtab: any
// }

export const Liste = () => {
  const { filterdroits } = useSelector((state: IReduxState) => state.droits);



  return (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        alignSelf: "center",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      <Header />

      <div style={{ marginTop: 5 }}>
        <div
          style={{
            fontWeight: "bold",
            textTransform: "uppercase",
            fontFamily: "Arial",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            display: "flex",
          }}
        >
          <span
            style={{
              border: "2px solid black",
              textAlign: "center",
              fontSize: 14,
              marginBottom: 10,
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              display: "flex",
              fontFamily: "arial",
              marginTop: 10,
              padding: 3,
              fontWeight: "bold",
              width: "50%"
            }}
          >
            {`Liste des droits utilisateur`}
          </span>
        </div>

        {/* {filteredArticles?.map(
          (items: IArticle, index: number) => ( */}

        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <span
                style={{
                  fontSize: 14,
                  fontFamily: "arial",
                  marginTop: 10,
                  display: "flex",
                  fontWeight: 'bold'
                }}>
                {/* {items?.libArticle} */}
              </span>
            </div>
            <div style={{/*  marginLeft: 50, */ display: "flex" }}>
              <span
                style={{
                  textAlign: "center",
                  fontSize: 14,
                  fontFamily: "arial",
                  marginTop: 10,
                }}>
              </span>
            </div>
          </div>

          <div
            style={{
              // marginTop: 5,
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
            }}
          >
          </div>

          <div
            style={{
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              display: "flex",
            }}>
            <table
              style={{
                marginTop: 5,
                width: "100%",
                border: "1px solid black",
                borderCollapse: "collapse",
                fontFamily: "arial",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <thead
                style={{
                  fontWeight: "bold",
                  fontSize: 14,
                  border: "1px solid black",
                  color: "black",
                  borderCollapse: "collapse",
                  fontFamily: "arial",
                }}
              >
                <tr style={{ border: "1px solid black" }}>
                  <th
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      padding: 2,
                      // width: 20,
                      width: "auto",
                    }}
                  >
                    N°
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      border: "1px solid black",
                      // width: 100,
                      width: "auto",
                      padding: 2
                    }}
                  >
                    Libellé
                  </th>
                  <th
                    // colSpan={2}
                    style={{
                      textAlign: "left",
                      border: "1px solid black",
                      width: "auto",
                      // width: 210,
                      padding: 2
                    }}
                  >
                    Identifiant
                  </th>
                  <th
                    // colSpan={2}
                    style={{
                      textAlign: "left",
                      border: "1px solid black",
                      width: "auto",
                      // width: 210,
                      padding: 2
                    }}
                  >
                    Code descriptif
                  </th>
                </tr>
              </thead>

              {filterdroits?.map(
                (item, index: number) => (
                  <>
                    <tbody
                      style={{
                        fontSize: 9,
                        border: "1px solid black",
                        borderCollapse: "collapse",
                        fontFamily: "arial",
                        padding: "0px"
                      }}
                    >
                      <tr
                        key={index}
                      >
                        <td
                          style={{
                            textAlign: "center",
                            border: "1px solid black",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            textAlign: "left",
                            border: "1px solid black",
                            fontSize: 12,
                            // width: 100,
                            width: "auto",
                            // borderBottom: "none",
                          }}
                        >
                          {
                            `${item?.libDroit ? item?.libDroit : ""}`
                          }
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            border: "1px solid black",
                            fontSize: 12,
                            // width: 90,
                            width: "auto",
                            // borderTop: "none",
                          }}
                        >
                          {
                            `${item?.idDroit ? item?.idDroit : ""}`
                          }
                        </td>
                        <td
                          // colSpan={2}
                          style={{
                            border: "1px solid black",
                            paddingLeft: 5,
                            fontSize: 12,
                            // width: 210,
                            width: "auto",
                            // borderTop: "none",
                          }}
                        >
                          {
                            `${item?.descriptionDroit ? item?.descriptionDroit : ""}`
                          }
                        </td>
                      </tr>
                    </tbody>
                  </>
                ))}
            </table>
          </div>
        </>
        {/* )
        )} */}

      </div>
    </div>
  );
};
